var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 pb-2 bg-white rounded-lg h-100"},[_c('DataTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }